import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonEn from './resources/en/common.json';
import commonEs from './resources/es/common.json';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale } from './locales';

export const defaultNS = 'common';

export const resources = {
  en: { common: commonEn },
  es: { common: commonEs },
} as const;

/**
 * Translations are bundled rather than fetched: the locale is fixed by the URL
 * at render time, so a network round trip would only delay first paint.
 */
export function createI18n(locale: Locale = DEFAULT_LOCALE) {
  const instance = i18n.createInstance();
  void instance.use(initReactI18next).init({
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS,
    resources,
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return instance;
}

export default i18n;
